export const MAX_NUM_LETTERS = 6;
export const NUM_WORDS = 3;
